

const page_strings ={
	//nav
	"menu_item_home": "HOME",
	"menu_item_developer": "DEVELOPER",
	"menu_item_service": "SERVICE",
	"menu_item_brands": "BRANDS",
	"menu_item_medium": "MEDIUM",

	//main
	"page_company_name": "TAIWAN INTELLIGENT HOME",
	"page_title": "MAKE SMART HOME SMARTER",
	"page_subtitle": "CONTROL SMART HOME IN A SINGLE APP",
	"download_on": "DOWNLOAD ON",
	"our_service_title": "Our Service",
	"our_service_subtitle": "WHAT YOU CAN DO WITH TIH",

	"MaidWhite": "Maid White",
	"maid_white_desc": "Maid White is a platform which integrates software protocols of IoT devices. With Maid White, appliance companies or any interested developers can control IoT devices easily through RESTful API, with no need of learning lots of protocols such as MQTT or others self-developed by different companies.",
	"maid_white_meet_id": "Meet it",

	"app_dev": "APP Development",
	"app_dev_desc": "TIH develops APPs, provides suggestions about which module or cloud to use, and shares IoT APP implementation experiences to companies interested in entering the IoT field.",
	"irharuka_title": "I.R. Haruka",
	"irharuka_desc": "I.R. Haruka controls IR home appliances through Internet with a mobile app and an IR projector. Its open-source software and hardware allow users to personalize their device to fit various needs. Plus, it could work with the open-source Infrared database, IRDB, so that users do not need to teach I.R. Haruka to learn their remote controls.",
	"ryoku_simulator": "Ryoku Simulator",
	"ryoku_simulator_desc": "Ryouku Simulator is an open source project that helps access to Ryoku Cloud through web socket. Software developers can test if they controlled devices successfully using Ryoku Simulator which can decrease their costs of software development.",
	"meet_it": "Meet it",
	"irharuka_link_text": "Meet Haruka",
	"about_numbers_title": "Number Talks",
	"about_numbers_subtitle": "PROGRESS OF TIH IoT",
	"number_of_supported_brands": "BRANDS SUPPORTED BY TIH SERVICE",
	"number_of_requests": "REQUESTS HAVE BEEN SENT ON TIH CLOUD",
	"number_of_supported_devices": "DEVICES SUPPORT TIH CLOUD",
	"subscribe_by_email": "SUBSCRIBE EDM BY EMAIL",
	"follow_us_on_facebook": "FOLLOW US ON FACEBOOK",

	//popup
	"popup_subtitle": "Deal with your smart appliances for you.",
	"popup_can_alse": "Maid White can also",
	"popup_action_en": "“Hey Google,Turn on the lamp.”",
	"popup_action_local": "「幫我叫女僕小白。」",
	"popup_and_more": "and more…",

	//footer
	"tih_copyright": "Copyright © 2024 TIH Corp. All Rights Reserved.",
	"privacy_policy": "Privacy Policy",

	//supported brands
	"supported_brands_title": "Supported Brands",
	"model": "Model",
	"device_type": "Device Type",
	"remarks": "Remarks",


	"text_reveived_subscribe_mail_request" : "Received！", // 收到使用者要求訂閱電子報的訊息

	"html_description": "We are Taiwan Intelligent Home, A company that devoted to smart home integration. Our purpose is to build software industry chain of Taiwan.",
	"html_title": "TAIWAN INTELLIGENT HOME",

}

var privacy_policy = {
	"privacy_policy_title": "Privacy Policy",
	"privacy_policy_version": "Version: 2017101001-en",
	"privacy_policy_content_1": "Taiwan Intelligent Home Corp. (“TIH”, “us”, “we”, or “our”) respects and promises to protect your privacy. By using TIH website and services, you agree to TIH Privacy Policy. Please feel free to e-mail us if you have any question to our privacy policy; if you disagree with our privacy policy, please do not use the services provided by TIH.",
	"privacy_policy_content_2_1": "Information We Collect and How",
	"privacy_policy_content_2_2_1": "We may collect the following information when you use TIH services:",
	"privacy_policy_content_2_2_2_1": "E-mail address",
	"privacy_policy_content_2_2_2_2": "Device information",
	"privacy_policy_content_2_2_2_3": "Device log information",
	"privacy_policy_content_2_2_2_4": "Internet requests, including Internet protocol address, browser type, browser language, date, and time… etc..",
	"privacy_policy_content_3_1": "How We Make Use of Your Information",
	"privacy_policy_content_3_2_1": "We can use collected information for the following purposes:",
	"privacy_policy_content_3_2_2_1": "provide, maintain, improve our products and services",
	"privacy_policy_content_3_2_2_2": "develop new products and services",
	"privacy_policy_content_3_2_2_3": "user experiences and marketing analysis",
	"privacy_policy_content_3_2_2_4_1": "provide permission to control your devices to third-party developers you trust with your consent, including",
	"privacy_policy_content_3_2_2_4_2_1": "control device",
	"privacy_policy_content_3_2_2_4_2_2": "access device status",
	"privacy_policy_content_3_2_2_4_2_3": "access behavior log",
	"privacy_policy_content_3_2_2_5": "other purposes with your consent",
	"privacy_policy_content_3_2_2_6": "provide information to the authorities for legal reasons",
	"privacy_policy_content_4_1": "Cross-border Data Transmission",
	"privacy_policy_content_4_2": "TIH uses servers located in different countries and regions, that means your personal information may be processed on the servers located inside or outside Taiwan.",
	"privacy_policy_content_5_1": "Cookie and Similar Technologies",
	"privacy_policy_content_5_2": "TIH uses cookie to login your account with OAuth standard and track the number you visited our website, services, and the webpages and functions you access.",
}

var strings = {...page_strings, ...privacy_policy}


export default strings;
